module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foot page"
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ad"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.recordation)), (_vm.data.recordcode) ? _c('span', {
    staticClass: "copyright"
  }, [_vm._v(_vm._s(_vm.data.recordcode))]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("出版物经营许可证  新出发津零字第V065号")]), _vm._v(" "), _c('p', [_vm._v("营业执照 91120116MA05JPR99J")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.company))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.copyright))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/foot-logo-new.png"),
      "height": "88",
      "width": "88"
    }
  }), _vm._v("\n                知识就在得到\n            ")]), _vm._v(" "), _c('p', [_vm._v("客服电话: 400-0526-000")]), _vm._v(" "), _c('p', [_vm._v("邮箱: "), _c('a', {
    attrs: {
      "href": "mailto:iget@luojilab.com"
    }
  }, [_vm._v("iget@luojilab.com")])]), _vm._v(" "), _c('p', [_vm._v("联系地址: 北京市朝阳区华贸商务楼20号楼")]), _vm._v(" "), _c('div', {
    staticClass: "follow"
  }, [_c('span', [_vm._v("关注我们: ")]), _vm._v(" "), _c('a', {
    staticClass: "wb",
    attrs: {
      "href": "http://weibo.com/u/5745019302?topnav=1&wvr=6&topsug=1&is_all=1"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/gzh.png"),
      "height": "88",
      "width": "88"
    }
  }), _vm._v("\n            微信扫码  关注「得到」公众号\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-245dc351"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/www/Components/Footer.vue
// module id = 44
// module chunks = 8